import React, { useState } from "react";
import { Box, Typography, Tabs, Tab, Paper } from "@mui/material";
import UserLoginHistoryTab from "../components/logs/UserLoginHistoryTab";
import { AppTab, AppTabPanel } from "components/common/tabs";

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function LogsPage() {
  const [value, setValue] = useState(0);
  const tabs = [
    { label: "Lịch sử đăng nhập", value: 0 },
  ];

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Paper
        sx={{ width: "100%", border: "1px solid #e0e0e0", borderRadius: 1 }}
      >
        <>
          <AppTab
            value={value}
            onChange={handleChange}
            tabs={tabs}
          />
        </>

        <AppTabPanel value={value} index={0}>
          {value === 0 && <UserLoginHistoryTab />}
        </AppTabPanel>

      </Paper>
    </Box>
  );
}

export default LogsPage;
